import {isNil, isNotNil} from 'ramda';

import {getSafely, parseDate} from 'shared/web';

import {AvailableCar} from '../../../../types/AvailableCar';

type PriceChange = {price: number; date: number};

export function getPriceChanges(vehicle?: AvailableCar | null) {
  return (
    vehicle?.price_changes
      ?.map((price, index) => {
        const date = parseDate(getSafely(vehicle.price_changes_dates, index))?.getTime();

        return isNil(date) ? undefined : {price, date};
      })
      .filter((priceChange): priceChange is PriceChange => isNotNil(priceChange))
      .sort((a, b) => a.date - b.date) ?? []
  );
}
